import { render, staticRenderFns } from "./amounts.vue?vue&type=template&id=6728599c"
import script from "./amounts.vue?vue&type=script&lang=js"
export * from "./amounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports